import { Dialog } from '@cmsgov/ds-medicare-gov';
import { useEffect } from 'react';
import { helpDrawerClosed, helpDrawerOpened } from '../analytics';
import '../css/dialog.css';
import translate from '../functions/translate';
import medicareCard from '../images/medicare-card-partab-new.png';
import X from '../images/x.svg';
import Button from './button';
import Div from './div';
import H2 from './h2';
import TranslatedSpan from './TranslatedSpan';

interface MedicareStartDateDialogProps {
    isOpen: boolean
    onExit: () => void
    part: 'A' | 'B'
}

const MedicareStartDateDialog = (props: MedicareStartDateDialogProps) => {
    const headerText = translate('where_to_find_your_part');
    useEffect(() => {
        if (props.isOpen) {
            helpDrawerOpened(headerText, headerText);
        }
    }, [props.isOpen, headerText]);

    const exit = () => {
        props.onExit();
        helpDrawerClosed(headerText);
    }

    if (!props.isOpen)
        return null;
    return <>
        <Dialog
            className={'drawer-dialog'}
            getApplicationNode={() => document.getElementById('App')}
            headerClassName={'drawer-dialog-header'}
            onExit={props.onExit}
            underlayClickExits={true}
        >
            <H2>
                <div style={{
                    cursor: 'pointer',
                    float: 'right',
                }}>
                    <Button
                        aria-label={translate('close')}
                        variation={'ghost'}
                        onClick={exit}
                    >
                        <img
                            alt={translate('close')}
                            src={X}
                            style={{
                                position: 'relative',
                                bottom: 15,
                                left: 15,
                            }}
                        />
                    </Button>
                </div>
                <div>
                    <TranslatedSpan
                        english={'where_to_find_your_part'}
                        replacements={{letter: props.part}}
                    />
                </div>
            </H2>
            <Div paddingyMD={1} paddingyXL={2}>
                <TranslatedSpan english={'check_medicare_card_call_for_help'}/>
            </Div>
            <Div
                paddingyMD={1} paddingyXL={2}
                style={{textAlign: 'center'}}
            >
                <img
                    alt={translate('medicare_card_example')}
                    src={medicareCard}
                    style={{
                        maxWidth: 400,
                        width: '100%',
                    }}
                />
            </Div>
        </Dialog>
    </>
}
export default MedicareStartDateDialog;
